module.exports = __webpack_public_path__ + "static/media/7f931369.jpg";